export const generatePageRange = (
  siblingCount: number,
  currentPage: number,
  totalPages: number
) => {
  const totalButtons = siblingCount * 2 + 1;

  let start = Math.max(1, currentPage - siblingCount);
  let end = Math.min(totalPages, currentPage + siblingCount);

  if (end - start < totalButtons - 1) {
    start = Math.max(1, end - totalButtons + 1);
  }
  if (currentPage - siblingCount < 1) {
    start = 1;
    end = Math.min(totalButtons, totalPages);
  }
  return [...Array(end - start + 1)].map((_, index) => start + index);
};
